"use strict";
var NavigationConverter = (function () {
    function NavigationConverter() {
    }
    NavigationConverter.convert = function (navigations) {
        return navigations.reduce(function (refinements, navigation) {
            navigation.refinements
                .forEach(function (refinement) { return refinements.push(Object.assign(refinement, { navigationName: navigation.name })); });
            return refinements;
        }, []);
    };
    return NavigationConverter;
}());
exports.NavigationConverter = NavigationConverter;



//////////////////
// WEBPACK FOOTER
// ./~/groupby-api/dist/src/utils/converter.js
// module id = 137
// module chunks = 0